import { apiFetch, noop, reportTo, run } from "../api";
import { selectSessionId } from "./app-slice";

export const activityPath = (groupId, before = null) =>
  `/groups/${groupId}/activity${before == null ? "" : `?before=${before}`}`;

export const loadActivity =
  (groupId, before, onSuccess = noop, onError = noop) =>
  (dispatch, getState) =>
    run(
      apiFetch(selectSessionId(getState()), activityPath(groupId, before)),
      onSuccess,
      reportTo(onError, "Der Verlauf konnte nicht geladen werden."),
    );
